import { computed, ComputedRef, ref } from 'vue';
import { client, getCsrfToken, kickUserOut } from '@/graphql/client';
import { MeDocument, User } from '@/graphql/operations';
import { BroadcastingConnect } from './useBroadcasting';

const state = ref({ user: {} as User });

const getUser: ComputedRef<User> = computed(() => {
    return state.value.user;
});

const check = (): boolean => {
    if (Object.entries(state.value.user).length !== 0) {
        BroadcastingConnect();
        return true;
    }

    return false;
};

const clear = (): void => {
    state.value.user = {} as User;
};

function setUser (user: User): void {
    state.value.user = user;
}

async function fetchUser (): Promise<void> {
    if (!getCsrfToken()) {
        return kickUserOut();
    }

    const result = await client.executeQuery({ query: MeDocument });

    if (![419, 401].includes(result.error?.response?.status) && result.data) {
        setUser(result.data.me as User);
    }
}

const isLoggedIn = computed(() => {
    return Boolean(state.value.user?.email);
});

const hasValidUser = computed(() => {
    return isLoggedIn.value && state.value.user.person?.prefixedId;
});

const userState = {
    getUser,
    isLoggedIn,
    hasValidUser,
    clear,
    check
};

export { userState, fetchUser };
